import * as React from "react"

const Footer = () => (
  <div className="footer">
    <div className='p40 pb20 text-center small op-50'>
      © Swift Car Sales {new Date().getFullYear()}. Site by <a target="_blank" rel="noreferrer" href="https://groundcrew.com.au/">Groundcrew</a>
    </div>
  </div>
)
export default Footer
